import { motion } from "framer-motion";
import { Layers, Network, ShieldCheck, Workflow } from "lucide-react";

const VALUES = [
  {
    id: "scalability",
    n: "01",
    title: "Scalability",
    kr: "확장 가능한 구조 설계",
    desc: "비즈니스 성장에 맞춰 자연스럽게 확장되는 아키텍처를 설계합니다.",
    Icon: Layers,
  },
  {
    id: "connectivity",
    n: "02",
    title: "Connectivity",
    kr: "서비스와 데이터를 연결",
    desc: "분리된 서비스, 데이터, 운영 시스템을 하나의 흐름으로 연결합니다.",
    Icon: Network,
  },
  {
    id: "innovation",
    n: "03",
    title: "Innovation",
    kr: "AI 기반 디지털 혁신",
    desc: "AI와 자동화를 비즈니스 프로세스의 핵심으로 통합합니다.",
    Icon: Workflow,
  },
  {
    id: "reliability",
    n: "04",
    title: "Reliability",
    kr: "안정적인 운영과 유지보수",
    desc: "장애 없는 운영, 예측 가능한 유지보수로 신뢰를 만듭니다.",
    Icon: ShieldCheck,
  },
];

export default function CoreValueSection() {
  return (
    <section
      id="value"
      data-testid="corevalue-section"
      className="relative bg-[#F8FAFC] py-24 md:py-32 border-y border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <div className="text-xs font-semibold tracking-[0.25em] uppercase text-[#0A2540]">
            Core Value — 02
          </div>
          <h2 className="font-display font-kr mt-5 text-4xl md:text-5xl font-bold tracking-tight leading-[1.1]">
            우리가 일하는 4가지 기준.
          </h2>
          <p className="font-kr mt-5 text-base md:text-lg text-slate-600 leading-relaxed">
            기술적 완성도보다 비즈니스의 지속 가능성을 먼저 생각합니다.
          </p>
        </motion.div>

        <div className="mt-14 md:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {VALUES.map((v, i) => (
            <motion.div
              key={v.id}
              data-testid={`corevalue-card-${v.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.55, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="group p-7 md:p-8 rounded-3xl bg-white border border-slate-100 hover:border-[#0A2540]/15 hover:-translate-y-1 transition-all duration-300 shadow-[0_1px_2px_rgba(15,23,42,0.04)] hover:shadow-[0_24px_60px_-24px_rgba(10,37,64,0.18)]"
            >
              <div className="flex items-center justify-between">
                <div className="h-11 w-11 rounded-xl bg-[#0A2540]/5 text-[#0A2540] flex items-center justify-center group-hover:bg-[#0A2540] group-hover:text-white transition-colors">
                  <v.Icon size={20} strokeWidth={1.6} />
                </div>
                <span className="font-display text-sm font-semibold text-slate-300 tracking-tight">{v.n}</span>
              </div>
              <h3 className="font-display mt-7 text-xl md:text-[22px] font-bold tracking-tight text-slate-900">
                {v.title}
              </h3>
              <div className="font-kr mt-1 text-sm font-medium text-[#0A2540]">{v.kr}</div>
              <p className="font-kr mt-4 text-sm text-slate-600 leading-relaxed">{v.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
